import { pushDatalayer } from '../utilities/datalayer';

export default class PaneDatalayer {
    constructor(el) {
        this.DOM = { el: el };
        this.paneDatalayer = JSON.parse(this.DOM.el.dataset.paneDatalayer || '{}');

        pushDatalayer(this.paneDatalayer);
    }
}

const paneDatalayerNodes = Array.from(document.querySelectorAll('[data-pane-datalayer]'));
if (paneDatalayerNodes !== null) {
    paneDatalayerNodes.forEach((node) => { new PaneDatalayer(node); });
}
